import {
    PUBLIC_FILES_ROUTE_PREFIX,
    LEAD_FORM_EMBED_FLOWS_ROUTE_PREFIX
} from '~/constants/client-experience.consts';

export const isPublicFlowRoute = () => {
    const { pathname } = window.location;
    return (
        pathname.startsWith(PUBLIC_FILES_ROUTE_PREFIX) ||
        pathname.startsWith(LEAD_FORM_EMBED_FLOWS_ROUTE_PREFIX)
    );
};
